import React from "react";
import "./index.css";
import { useSelector } from "react-redux";

const ProfileCompletionWidget = () => {
  const percent = useSelector(
    (store) => store.auth.userData.profileCompletionLevelPercent
  );
  const isComplete = percent === 100;
  const iconClass = percent >= 80 ? "green" : "yellow";

  return (
    <div className="profile-widget">
      <h2>Profile Completion</h2>
      <p className="description">
        {isComplete
          ? "Great job! Your profile is complete."
          : `You're ${100 - percent}% away from completing your profile.`}
      </p>

      <div className="progress-bar">
        <div
          className="progress-bar-fill"
          style={{ width: `${percent}%` }}
        ></div>
      </div>

      <div className="status-row">
        <div className="status-left">
          <span className={`status-icon ${iconClass}`}>●</span>
          <span>
            {isComplete
              ? "All steps completed"
              : percent >= 80
                ? "Almost there!"
                : "More steps needed"}
          </span>
        </div>
        {!isComplete && (
          <a href="/profile/edit/basic" className="complete-link">
            Complete Now →
          </a>
        )}
      </div>
    </div>
  );
};

export default ProfileCompletionWidget;
